import Quill from 'quill';
const Parchment = Quill.import('parchment');

// Custom indent attributor for QuillJS to apply inline style
// class IndentAttributor extends Parchment.Attributor.Style {
//   constructor(name: string, style: string, params: any) {
//     super(name, style, params);
//   }
//   add(node: any, value: any) {
//     if (value === 0) {
//       (<any>this).remove(node);
//       return true;
//     } else {
//       return super.add(node, `${value}em`);
//     }
//   }
// }
// let IndentStyle = new IndentAttributor('indent', 'text-indent', {
//   scope: Parchment.Scope.BLOCK,
//   whitelist: ['1em', '2em', '3em', '4em', '5em', '6em', '7em', '8em', '9em']
// });

class IndentAttributor extends Parchment.Attributor.Style {
  multiplier = 2;

  constructor(name: string, style: string, params: any) {
    super(name, style, params);
  }

  add(node: any, value: any) {
    return super.add(node, `${value * this.multiplier}rem`);
  }

  value(node: any) {
    return parseFloat(super.value(node)) / this.multiplier || undefined;
  }
}

const levels = [1, 2, 3, 4, 5, 6, 7, 8, 9];
const multiplier = 2;

let IndentStyle = new IndentAttributor('indent', 'margin-left', {
  scope: Quill.import('parchment').Scope.BLOCK,
  whitelist: levels.map(value => `${value * multiplier}rem`)
});

export { IndentStyle };
